"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DisabledOverlay_component_exports = {};
__export(DisabledOverlay_component_exports, {
  DisabledOverlay: () => DisabledOverlay,
  default: () => DisabledOverlay_component_default
});
module.exports = __toCommonJS(DisabledOverlay_component_exports);
var import_styled_components = __toESM(require("styled-components"));
var DisabledOverlay = import_styled_components.default.div.withConfig({
  displayName: "DisabledOverlaycomponent__DisabledOverlay",
  componentId: "sc-1p3w42v-0"
})(function(_ref) {
  var theme = _ref.theme, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
  return "\n  background: ".concat(isDisabled ? theme.colors.white : "none", ";\n  opacity: ").concat(isDisabled ? "0.5" : "1", ";\n  pointer-events: ").concat(isDisabled ? "none" : "initial", ";\n  border-radius: inherit;\n  height: 100%;\n");
});
var DisabledOverlay_component_default = DisabledOverlay;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DisabledOverlay
});
//# sourceMappingURL=DisabledOverlay.component.js.map